import { Toggle } from '@client/components/common/inputs/Toggle';
import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';

export const AMRAPSwitch = ({
  onChange,
  value,
}: {
  onChange: (value: boolean) => void;
  value: boolean;
}) => {
  return (
    <Row alignCenter>
      <Typography>All reps AMRAP mode</Typography>
      <Toggle
        value={value}
        variant="primary"
        onChange={() => onChange(!value)}
      />
    </Row>
  );
};
